import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as s, createElementBlock as d, normalizeClass as l, createElementVNode as n } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconAsterisk",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function _(e, t, i, u, f, a) {
  return s(), d("svg", {
    "aria-label": i.ariaLabel,
    class: l([a.iconSizeClass, "d-icon d-icon--asterisk"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Asterisk",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...t[0] || (t[0] = [
    n("path", {
      d: "M6.5 3a.5.5 0 1 0-1 0v2.134L3.652 4.067a.5.5 0 0 0-.5.866L5 6 3.152 7.067a.5.5 0 1 0 .5.866L5.5 6.866V9a.5.5 0 0 0 1 0V6.866l1.848 1.067a.5.5 0 0 0 .5-.866L7 6l1.848-1.067a.5.5 0 0 0-.5-.866L6.5 5.134V3Z",
      fill: "currentColor"
    }, null, -1)
  ])], 10, m);
}
const b = /* @__PURE__ */ o(c, [["render", _]]);
export {
  b as default
};
//# sourceMappingURL=asterisk.js.map
